
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("ahk2K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;

var $77bb0a1fb2a0f6e7$var$_jquery = $77bb0a1fb2a0f6e7$var$_interopRequireDefault((parcelRequire("4kMWr")));
function $77bb0a1fb2a0f6e7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $77bb0a1fb2a0f6e7$var$init = module.exports.init = function init() {
    (0, $77bb0a1fb2a0f6e7$var$_jquery["default"])("[data-id='copy-iban']").on("click", function(e) {
        var $parent = (0, $77bb0a1fb2a0f6e7$var$_jquery["default"])(e.target).parents(".container");
        var $feedback = $parent.find(".IBAN-feedback");
        var $temp = (0, $77bb0a1fb2a0f6e7$var$_jquery["default"])("<input>");
        (0, $77bb0a1fb2a0f6e7$var$_jquery["default"])("body").append($temp);
        $temp.val((0, $77bb0a1fb2a0f6e7$var$_jquery["default"])("[data-id='iban-copy']").text()).select();
        document.execCommand("copy");
        $temp.remove();
        $feedback.slideDown(400, function() {
            setTimeout(function() {
                $feedback.slideUp(400);
            }, 5000);
        });
    });
};

});


//# sourceMappingURL=copyIban.module.154cab0c.js.map
